import React from 'react';

import TpDialog from '../shared/tp_dialog';
import { amount_text, who_view } from './adapters';
import { with_ist } from '../shared/ist';

/* the pre-save confirmations (large amount, look-alike entry). */
const ConfirmSaveModal = ({
  title,
  message,
  matches,
  saving,
  error_text,
  on_confirm,
  on_close,
  on_focus_lost,
  confirm_label = 'Save anyway',
  primary = null
}) => (
  <TpDialog
    title_id="tp-ap-confirm-title"
    title={title}
    size="sm"
    busy={saving}
    on_close={on_close}
    on_focus_lost={on_focus_lost}
  >
    <div className="tp-modal">
      <div className="tp-ctx">{message}</div>
      {error_text ? (
        <div className="tp-banner tp-banner-error" role="alert">
          {error_text}
        </div>
      ) : null}
      {matches.length ? (
        <ul className="tp-dup-list">
          {matches.map((m) => {
            const by = who_view(m.added_by_name, m.added_by);
            return (
              <li key={m.uuid}>
                {m.teacher_name} · {m.category_label || m.category} · {amount_text(m.amount)} ·{' '}
                {with_ist(m.entry_at_ist) || m.pay_month} · added by{' '}
                <span title={by.title}>{by.text}</span>
              </li>
            );
          })}
        </ul>
      ) : null}
      <div className="tp-modal-ft">
        {/* aria-disabled, not disabled: disabling the focused button drops focus. */}
        <button
          type="button"
          className="tp-btn-ghost"
          onClick={saving ? undefined : on_close}
          aria-disabled={saving ? 'true' : undefined}
        >
          Cancel
        </button>
        <button
          type="button"
          className={primary ? 'tp-btn-out' : 'tp-btn'}
          onClick={saving ? undefined : on_confirm}
          aria-disabled={saving ? 'true' : undefined}
        >
          {saving ? 'Saving…' : confirm_label}
        </button>
        {primary ? (
          <button
            type="button"
            className="tp-btn"
            onClick={saving ? undefined : primary.run}
            aria-disabled={saving ? 'true' : undefined}
          >
            {primary.label}
          </button>
        ) : null}
      </div>
    </div>
  </TpDialog>
);

export default ConfirmSaveModal;
